import { render } from "./TicketReport.vue?vue&type=template&id=07fea4c6"
import script from "./TicketReport.vue?vue&type=script&lang=ts"
export * from "./TicketReport.vue?vue&type=script&lang=ts"
script.render = render

export default script